export class HttpCode {
    static Success: number = 200;
    static NotFound: number = 404;
    static Forbidden: number = 403;
    static Unauthorized: number = 401;
    static InternalError: number = 500;
    static AxiosError: number = 0;
}